module.exports = __webpack_public_path__ + "img/3.ec7d9210.jpg";